import { CInputCheckbox, CTooltip } from "@coreui/react";
import APISererviceManager from "../../libs/apiSererviceManager";
import { getCookie } from "../../utils/cookies/CookieHandler";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import { authCookieName } from "../../utils/AuthenticationLibrary";
export default class BaseDomainService {

    pagination = {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
    };

    apiService;
    serviceManager;
    authUser;
    onUpdateState;
    onActionCall;
    onPaginationUpdate;
    actionKey;

    constructor() {
        this.authUser = getCookie(authCookieName);
        this.apiService = new APISererviceManager();
    }

    // Validation
    validateField = (key, data, rules, currentState) => {
        const isValidData = validate(key, data, rules, currentState);
        this.onUpdateState({ validState: isValidData });
    }
    isValidSubmit = (data, rules, currentState) => {
        const isValidData = isValidForm(data, rules, currentState);
        this.onUpdateState({ validState: isValidData });
        return isValidData.isValid;

    }
    //Redirect to other page
    onRedirect = (redirectUrl) => {
        this.onUpdateState({ redirect: redirectUrl });
    }
    // Pagination Metods
    onPageChange = (newPagination) => {
        this.pagination = newPagination;
        this.onUpdateState({ "pagination": newPagination }, () => {
            this.onPaginationUpdate(this.pagination);
        });
    }

    gridActionCol = (element, index, value) => {
        return (element !== this.actionKey) ? null
            : <td className="text-end">
                <CTooltip content="Edit" placement="top">
                    <i className="fas fa-pencil text-success" onClick={() => this.onActionCall("Edit", index)}></i>
                </CTooltip>
                <CTooltip content="Delete" placement="top">
                    <i className="fas fa-trash pl-3 text-danger" onClick={() => this.onActionCall("Delete", index)}></i>
                </CTooltip>
            </td>
    }
    gridActionMoveCol = (element, index, value) => {
        return (element !== this.actionKey) ? null
            :
            <td className="text-end">
                <CTooltip content="Back" placement="top">
                    <i className="fal fa-share-all status mr-2 fa-flip-horizontal" onClick={() => this.onActionCall("Back", index)}></i>
                </CTooltip>

            </td>
    }
    gridCheckBoxCol = (element, index, value) => {
        return (element !== "IsActive") ? null :
            <td>
                <CInputCheckbox
                    id="chkisActive"
                    name="checkbox1"
                    checked={value}
                    onChange={(e) => this.handleChange("isActive", e.target.checked, index)}
                />
            </td>


        //  <td className="text-left ml">
        //     <div className="form-check">
        //         <input disabled className="form-check-input ml-0" style={{ position: 'relative' }} type="checkbox" id="inlineFormCheck" checked={value} />
        //     </div>
        // </td>
    }
}
